import _ from 'lodash';

export type WeightedSet<T> = [T, number][];

export function weightedSet<T>(items: WeightedSet<T>): T[] {
  return items.flatMap(([item, weight]) => _.fill(Array(weight), item));
}
